import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { AppStateService } from '../../shared/services/app-state.service';
import { NetworkService } from '../../shared/services/network.service';
import { Alerts } from '../models/alerts.model';

@Injectable({
  providedIn: 'root'
})
export class AlertsService extends NetworkService {

  constructor(
    private http: HttpClient,
    injector: Injector
  ) { super(injector); }
  
  getAlerts(): Observable<Alerts[]> {
    const headers = new HttpHeaders().set('shouldAuth', 'false');
    return this.http.get<any>(`${environment.apiGatewayUrl}/alerts`, { headers: headers }).pipe(
      map((resp: any) => {
        const data = resp?.body;
        return Array.isArray(data) ? (data as Alerts[]) : [];
      }),
      catchError(() => of([]))
    );
  }
}
